var render = function render(){var _vm=this,_c=_vm._self._c;return _c('crud-modal',{attrs:{"title":_vm.$t('modals.user.editTitle'),"action":"update","on-submit":_vm.submit,"on-close":() => _vm.$emit('close'),"validation-scope":"user"}},[_c('user-form',{attrs:{"company-id":_vm.companyId,"user":_vm.user,"disabled":['email'],"settings":_vm.userWithNotificationSettings}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }